import createGeodesicGeojson from "mapbox-gl-draw-geodesic/src/utils/create_geodesic_geojson";
import * as CommonSelectors from "@mapbox/mapbox-gl-draw/src/lib/common_selectors";
import pinia, { useMap } from "@/services";

let escKeyPressed = false;

function patchDrawPolygon(DrawPolygon) {
  const DrawPolygonPatched = { ...DrawPolygon };

  DrawPolygonPatched.toDisplayFeatures = function (state, geojson, display) {
    const displayGeodesic = (gj) => {
      const geodesicGeojson = createGeodesicGeojson(gj, { ctx: this._ctx });
      geodesicGeojson.forEach(display);
    };
    DrawPolygon.toDisplayFeatures.call(this, state, geojson, displayGeodesic);
  };

  DrawPolygonPatched.onStop = function (state) {
    DrawPolygon.onStop.call(this, state);

    setTimeout(() => {
      if (useMap(pinia).isEditingLayer) {
        useMap(pinia).editLayer.polygon = {
          coordinates: state.polygon.coordinates,
          type: state.polygon.type,
        };
        return;
      }

      if (useMap(pinia).editingMode.mode === "draw_polygon" && !escKeyPressed) {
        useMap(pinia).editingMode = {
          ...useMap(pinia).editingMode,
          mode: "simple_select",
        };
      } else {
        escKeyPressed = false;
      }
    });
  };

  DrawPolygonPatched.onKeyUp = function (state, e) {
    DrawPolygon.onKeyUp.call(this, state, e);
    if (CommonSelectors.isEscapeKey(e)) {
      escKeyPressed = true;
    }
  };

  return DrawPolygonPatched;
}

export default patchDrawPolygon;
